<template>
  <div class="header">
    <div class="card">
      <router-link tag="div" :to="to ? to : ''" class="flex align-center justify-between">
        <div class="flex align-center">
          <img :src="header.avatar" alt="" class="avator mr-16">
          <strong class="w-200 fs-18 van-ellipsis">{{ header.name }}</strong>
        </div>
        <van-icon name="arrow" class="color-9DA4B3" />
      </router-link>
      <div class="count flex align-center justify-between">
        <router-link tag="div" :to="header.toLink[0]">
          <strong class="fs-24">{{ header.count[0] | formatAmount }}</strong>
          <p class="color-9DA4B3">{{ header.words[0] }}</p>
        </router-link>
        <router-link v-show="header.words[1] === '我的代理' ? header.count[1] > 0 : true" tag="div" :to="header.toLink[1]">
          <strong class="fs-24">{{ header.count[1] | formatAmount }}</strong>
          <p class="color-9DA4B3">{{ header.words[1] }}</p>
        </router-link>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'CardHeader',
  props: {
    header: {
      type: Object
    },
    to: {
      type: String
    }
  }
}
</script>

<style lang="scss" scoped>
.avator{
  width: 40px;
  height: 40px;
  border-radius: 50%;
}
.card{
  width: 343px;
  margin: 10px auto;
}
.count{
  font-size: 12px;
  color: #0D0E15;
  margin: 5px 24px 0;
  text-align: center;
}
</style>
